import * as v from "valibot"

// Heavy item schema used in multiple forms
const HeavyItemSchema = v.object({
  name: v.pipe(v.string(), v.minLength(1, "Název je povinný")),
  weight: v.pipe(v.number(), v.minValue(100, "Minimální váha je 100 kg")),
  fitsInElevator: v.boolean(),
})

const AddressSchema = v.object({
  title: v.string(),
  subtitle: v.string(),
  location: v.object({
    lon: v.number(),
    lat: v.number(),
    municipality: v.string(),
    address: v.string(),
  }),
})


const AddressFieldSchema = v.pipe(
    v.nonNullable(
        v.union([v.null(), AddressSchema]),
        "Vyberte adresu z nabídky",
    ),
    v.check(
        (val) => Boolean(val.location?.address),
        "Vyberte adresu z nabídky",
    ),
);

// Stopover address schema for clearance form
const ClearanceStopoverAddressSchema = v.object({
  address: AddressFieldSchema,
  floor: v.pipe(v.number(), v.minValue(-10), v.maxValue(100)),
  elevator: v.boolean(),
})


type StopoverAddressType = v.InferOutput<typeof ClearanceStopoverAddressSchema>;

export const ClearanceWaypointsSchema = v.object({
    fromAddress: ClearanceStopoverAddressSchema,
});


export const ServiceContactSchema = v.object({
    email: v.pipe(
        v.string(),
        v.email("Invalid email address.")
    ),
    phone: v.pipe(
        v.string(),
        v.minLength(7, "Phone number is too short."),
        v.maxLength(20, "Phone number is too long.")
    ),
    serviceDates: v.pipe(
        v.array(
            v.pipe(
                v.union([v.string(), v.date()]),
                v.transform((value) => new Date(value)),
                v.date()
            )
        ),
        v.minLength(1, "Vyberte alespoň jeden termín")
    ),
    note: v.optional(
        v.pipe(
            v.string(),
            v.maxLength(500, "Note must be 500 characters or less.")
        )
    ),
});

const CountedServiceSchema = v.pipe(
    v.number(),
    v.minValue(0, "Počet musí být nezáporný"),
);


export const CLEARANCE__SERVICES_DEFINITION = [
    {key: "night_work",      label: "Práce v noci"},
    {key: "bugs",            label: "Štěnice, švábi a podobné"},
    {key: "hazardous_waste", label: "Nebezpečný odpad"},
] as const;

type ClearanceServiceOptionKey = (typeof CLEARANCE__SERVICES_DEFINITION)[number]["key"];

export const CLEARANCE__COUNTED_SERVICES_DEFINITION = [
    {key: "waste_volume", label: "Přibližný objem odpadu",  unit: "m3"},
    {key: "worker_count", label: "Počet pracovníků",        unit: "m3"},
] as const;


type ClearanceCountedServiceOptionKey = (typeof CLEARANCE__COUNTED_SERVICES_DEFINITION)[number]["key"];


export const CLEARANCE__SERVICE_BY_KEY =
    Object.fromEntries(CLEARANCE__SERVICES_DEFINITION.map(sd => [sd.key, sd]));

export const CLEARANCE__COUNTED_SERVICE_BY_KEY =
    Object.fromEntries(CLEARANCE__COUNTED_SERVICES_DEFINITION.map(sd => [sd.key, sd]));


const booleanServicesShape = Object.fromEntries(
    CLEARANCE__SERVICES_DEFINITION.map((service) => [service.key, v.optional(v.boolean(), false)] as const),
);

const countedServicesShape = Object.fromEntries(
    CLEARANCE__COUNTED_SERVICES_DEFINITION.map((service) => [service.key, v.pipe(v.number(), v.minValue(0))] as const),
);


export const ClearanceServicesSchema = v.object({
    heavyItems: v.array(HeavyItemSchema),
    booleanServices: v.object(booleanServicesShape),
    countedServices: v.object(countedServicesShape),
})


export type AddressItem = v.InferOutput<typeof AddressSchema>
